import * as React from 'react';

import { RoomViewModel } from 'models';

import { roomRatePlansWrapperLoadable } from 'components/infosite/rooms-and-rates/loadable';

const RatePlansWrapperLoadable = roomRatePlansWrapperLoadable.codeSplit as any;

export interface RoomRatesSegmentProps {
  position: string;
  room: RoomViewModel;
  excludeReserveButton: boolean;
  isPinnedRatePlan?: boolean;
  rffr?: string;
  excludePriceBreakDownLink?: boolean;
  layerId?: string;
}

export const RoomRatesSegment = ({
  position,
  room,
  excludeReserveButton,
  isPinnedRatePlan,
  rffr,
  excludePriceBreakDownLink,
  layerId,
}: RoomRatesSegmentProps) => {
  const hasPosition = Boolean(position);

  if (!(room && hasPosition)) {
    return null;
  }

  return (
    <section className="uitk-cell" data-stid="room-info-rate-options">
      <RatePlansWrapperLoadable
        id="infosite-room-info-dialog-ratePlans"
        optionBaseIndex={0}
        position={position}
        ratePlanCollection={room.ratePlans}
        room={room}
        trackingRfrr={rffr}
        excludeReserveButton={excludeReserveButton}
        isPinnedRatePlan={isPinnedRatePlan}
        excludePriceBreakDownLink={excludePriceBreakDownLink}
        layerId={layerId}
      />
      <RatePlansWrapperLoadable
        id="infosite-room-info-dialog-unavailableRatePlans"
        optionBaseIndex={0}
        position={position}
        ratePlanCollection={room.unavailableRatePlans}
        room={room}
        trackingRfrr={rffr}
        excludeReserveButton={excludeReserveButton}
        excludePriceBreakDownLink={excludePriceBreakDownLink}
        layerId={layerId}
      />
    </section>
  );
};
